<script>
  const { fillColor = "#000" } = $props();
</script>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM15.707 8.30664L13.0137 10.999H15V12.999H13V13.5996H15V15.5996H13V17.5996H11V15.5996H9V13.5996H11V12.999L9 13V11L10.9854 10.999L8.29297 8.30664L9.70703 6.89258L12 9.18555L14.293 6.89258L15.707 8.30664Z" fill={fillColor}/>
</svg>
